import Vue from 'vue'
import Vuex from 'vuex'
import Categorias from './categorias'
import Productos from './productos'
import App from './app'
import Carrito from './carrito'
import Cuenta from './cuenta'
import Checkout from './checkout'
Vue.use(Vuex)

const modules = {
  Categorias,
  Productos,
  App,
  Carrito,
  Cuenta,
  Checkout
}

export default new Vuex.Store({
  modules
})
